// removed by extract-text-webpack-plugin
module.exports = {"nav":"_1G2C6","dock":"_3fTO1","left":"abH6C","right":"aCd9j","iconLink":"_2dICi"};


/*****************
 ** WEBPACK FOOTER
 ** ./web_modules/Header/index.css
 ** module id = 497
 ** module chunks = 0
 **/